var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded text-md text-grey cursor-pointer hover:text-recess",on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-chevron-left text-xs mr-2"}),_c('span',[_vm._v("Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }